// extracted by mini-css-extract-plugin
export default {"root":"root--W96zH","link":"link--PQDJd","text":"text--Cnvy5"};